"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * @description Metoda pozwalająca na szybką iterację po kluczach obiektu
 * @function
 *
 * @param {Object} store Obiekt po którego kluczach będziemy iterować
 * @param {Function(string)} cb Funkcja wykonywana dla każdego klucza
 */
exports.default = (function (store, cb) {
    if (store && store instanceof Object) {
        var keys = Object.keys(store);
        var length_1 = keys.length;
        for (var i = 0; i < length_1; i += 1) {
            cb(keys[i]);
        }
    }
});
